/**
 * Switches the selected customer & reloads the app so everything is re-fetched for that customer.
 * Throws the error message when the customer could not be selected.
 */
export function useSwitchCustomer() {
  const router = useRouter();
  const storage = useLocalStorage();
  const customersStore = useCustomersStore();

  const switchCustomer = async (customerId: number) => {
    await customersStore.readCustomerById(customerId);
    storage.removeItem('sphere-pages');
    router.go(0);
  };

  return {switchCustomer};
}
